import type { App } from 'vue';
import { createGtm } from '@gtm-support/vue-gtm';
import type { Router } from 'vue-router';
import { getRegion } from '@telecom/shared/utils/environment';
import { DeployEnv } from '@patsnap-utils/biz';

/**
 * GTM (Google Tag Manager) Vue 插件
 *
 * 在海外环境中自动初始化 GTM，支持路由跟踪
 */
export const GtmPlugin = {
    install(app: App, router: Router) {
        if (!router) return;
        const region = getRegion();
        const queryParams = [DeployEnv.QA, DeployEnv.STAGE].includes(region)
            ? {
                gtm_auth: '8DXn90HL4Cs9q2B2FcbkxA',
                gtm_preview: 'env-92',
                gtm_cookies_win: 'x',
            }
            : undefined;

        if ([DeployEnv.US, DeployEnv.EU, DeployEnv.QA, DeployEnv.STAGE].includes(region)) {
            app.use(createGtm({
                id: 'GTM-PRDLLN6',
                queryParams,
                // @ts-ignore
                vueRouter: router,
                trackOnNextTick: true,
                ignoredViews: [],
                defer: true,
                compatibility: false,
                enabled: true,
                debug: [DeployEnv.QA, DeployEnv.STAGE].includes(region),
            }));
        }
    },
};
